export default "__VITE_ASSET__BFg6FeS$__"